import { newE2EPage } from '@stencil/core/testing';

describe('jackery-button', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-button></jackery-button>');

    const element = await page.find('jackery-button');
    expect(element).toHaveClass('hydrated');
  });
});
